import { Stack } from "@mui/material";
import { API_BASE_URL } from "../../../../config/urls";
import { ApiLine, HelperText, ReadOnlyField, SectionTitle, SubSection } from "./OtpPanelParts";

const ENDPOINTS = [
  "/api/v2/otp/generate/",
  "/api/v2/otp/verify/",
  "/api/v2/otp/resend/",
];

// Display only: the executors call the OTP service for the current business directly, so
// nothing here is configured, stored in the flow, or sent anywhere.
const OtpConnectionPreset = () => {
  const host = API_BASE_URL.startsWith("http")
    ? API_BASE_URL.replace(/\/api$/, "")
    : window.location.origin;

  return (
    <Stack spacing={3}>
      <ReadOnlyField label="Base Host URL" value={host} />
      <ReadOnlyField label="Bearer Token" type="password" value="••••••••••••" />
      <ReadOnlyField
        label="Business"
        value={localStorage.getItem("tenant")}
        helperText="Sent as the X-Tenant-ID header."
      />

      <SectionTitle>Used By</SectionTitle>
      <SubSection>
        {ENDPOINTS.map((endpoint) => (
          <ApiLine key={endpoint} path={endpoint} />
        ))}
      </SubSection>
      <HelperText>
        Values come from your account and can't be edited here. The token is never shown.
      </HelperText>
    </Stack>
  );
};

export default OtpConnectionPreset;
